import styled from 'styled-components';

export const Header = styled.div`
  align-items: center;
  border-bottom: 2px solid rgba(255, 255, 255, 0.3);
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
  margin-bottom: 10px;
`;

export const HeaderContent = styled.div`
  align-items: center;
  display: flex;
`;

export const FieldType = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;

  label.panda-typography--theme-white {
    color: rgba(255, 255, 255, 0.7);
  }
`;
